module.exports = __webpack_public_path__ + "img/icon_app_on.5e2d7a2d.svg";